import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";

export default function RecuperaPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err, "Si è verificato un errore. Riprova."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16 sm:px-6 animate-fade-up" data-testid="recupera-password-page">
      <div className="card-elegant">
        <h1 className="font-heading text-2xl font-bold text-bordeaux-dark sm:text-3xl">Recupera password</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Inserisci l'email con cui ti sei iscritto: ti invieremo un link per reimpostare la password.
        </p>

        {error && (
          <div data-testid="recupera-error" className="mt-4 rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">
            {error}
          </div>
        )}

        {sent ? (
          <div data-testid="recupera-success" className="mt-6 space-y-4">
            <div className="rounded-lg border border-green-300 bg-green-50 px-4 py-3 text-sm text-green-800">
              Se l'email è registrata, riceverai a breve un link per reimpostare la password. Controlla anche la cartella spam.
            </div>
            <p className="text-center text-sm text-muted-foreground">
              <Link to="/accedi" data-testid="recupera-back-login-link" className="font-semibold text-bordeaux hover:underline">
                Torna al login
              </Link>
            </p>
          </div>
        ) : (
          <form onSubmit={submit} noValidate className="mt-6 space-y-5" data-testid="recupera-form">
            <div>
              <label className="label-elegant" htmlFor="recupera-email">Email</label>
              <input id="recupera-email" type="email" data-testid="recupera-email-input" className="input-elegant" required
                value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button type="submit" disabled={loading} data-testid="recupera-submit-button" className="btn-bordeaux w-full">
              {loading ? "INVIO IN CORSO..." : "INVIA LINK DI REIMPOSTAZIONE"}
            </button>
            <p className="text-center text-sm text-muted-foreground">
              <Link to="/accedi" data-testid="recupera-login-link" className="font-semibold text-bordeaux hover:underline">
                Torna al login
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
